export const getColorForValue = (value: number) => {
  if (value < 0) {
    return '#1c2024'
  }
  const percentage = value / 100

  let lower = riskGradientStops[0]
  let upper = riskGradientStops[1]

  for (let i = 0; i < riskGradientStops.length - 1; i++) {
    if (percentage >= riskGradientStops[i][0] && percentage <= riskGradientStops[i + 1][0]) {
      lower = riskGradientStops[i]
      upper = riskGradientStops[i + 1]
      break
    }
  }

  const range = upper[0] - lower[0]
  const normalizedValue = (percentage - lower[0]) / range

  const color = interpolateColor(lower[1], upper[1], normalizedValue)
  return `rgb(${color[0]}, ${color[1]}, ${color[2]})`
}

export const getRiskScoreClass = (value: number): string => {
  if (value < 0) {
    return 'text-neutral-11'
  } else if (value >= 0 && value < 25) {
    return 'text-green-600'
  } else if (value >= 25 && value < 75) {
    return 'text-orange-500 dark:text-orange-400'
  } else if (value >= 75) {
    return 'text-red-500 dark:text-red-400'
  }
  return 'text-neutral-11'
}

export function interpolateColor(color1: number[], color2: number[], factor: number): number[] {
  return color1.map((c, i) => Math.round(c + factor * (color2[i] - c)))
}

export const riskGradientStops: [number, number[]][] = [
  [0, [64, 192, 87]],
  [0.4, [250, 176, 5]],
  [0.7, [230, 119, 0]],
  [1, [201, 42, 42]],
]

export const rgbRiskGradientStops: (string | number)[][] = riskGradientStops.map((stop) => {
  return [stop[0], `rgb(${stop[1][0]}, ${stop[1][1]}, ${stop[1][2]})`]
})
